export default "__VITE_ASSET__DuBSlWN2__"